import { render, staticRenderFns } from "./MetaDataUpdater.vue?vue&type=template&id=0b68ca42&scoped=true&"
import script from "./MetaDataUpdater.vue?vue&type=script&lang=js&"
export * from "./MetaDataUpdater.vue?vue&type=script&lang=js&"
import style0 from "./MetaDataUpdater.vue?vue&type=style&index=0&id=0b68ca42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b68ca42",
  null
  
)

export default component.exports